export const articlesListSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '攻略资讯 - 2pg·com 最新游戏攻略与平台资讯',
    url: 'https://2pg.com/articles',
    description: '2pg·com 最新游戏攻略、平台资讯、注册登录指南、账户安全解读等内容，帮助您快速了解平台并获得最佳游戏体验。',
    isPartOf: {
      '@type': 'WebSite',
      name: '2pg·com',
      url: 'https://2pg.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://2pg.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '攻略资讯',
        item: 'https://2pg.com/articles',
      },
    ],
  },
];